export default "__VITE_ASSET__CGdnuHSC__"